/**
 * 资料
 */

import Layout from '@/layout/Layout.vue'

export default {
  path: '/user',
  name: '用户',
  component: Layout,
  redirect: '/user/chat',
  children: [
    {
      name: '会话',
      path: 'chat',
      component: () => import('@/views/user/Chat.vue')
    },
    {
      name: '用户管理',
      path: 'user',
      component: () => import('@/views/user/User.vue'),
      meta: {
        keepAlive: true,
        pageName: 'user_user'
      }
    },
    {
      name: '支付流水',
      path: 'payment',
      component: () => import('@/views/user/payment/index.vue'),
      meta: {
        keepAlive: true,
        pageName: 'user_payment'
      }
    },
    {
      name: '角色管理',
      path: 'roles',
      component: () => import('@/views/user/roles/index.vue'),
      meta: {
        keepAlive: true,
        pageName: 'user_roles'
      }
    },
    {
      name: '权限管理',
      path: 'permission',
      component: () => import('@/views/user/permission/index.vue'),
      meta: {
        keepAlive: true,
        pageName: 'user_permission'
      }
    }
  ]
}
